import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import { Typography as Typography$2 } from './Typography.styles.js';

var _excluded = ["children", "customWeight", "rendersAs", "strikethrough", "variant"];
var Typography = function Typography(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$customWeight = _ref.customWeight,
    customWeight = _ref$customWeight === void 0 ? null : _ref$customWeight,
    _ref$rendersAs = _ref.rendersAs,
    rendersAs = _ref$rendersAs === void 0 ? null : _ref$rendersAs,
    _ref$strikethrough = _ref.strikethrough,
    strikethrough = _ref$strikethrough === void 0 ? false : _ref$strikethrough,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'body' : _ref$variant,
    props = _objectWithoutProperties(_ref, _excluded);
  var Component = Typography$2;
  if (rendersAs) {
    Component = Typography$2.withComponent(rendersAs, process.env.NODE_ENV === "production" ? {
      target: "e1hk20aw0"
    } : {
      target: "e1hk20aw0",
      label: "Component"
    });
  } else if (/h\d/.test(variant)) {
    Component = Typography$2.withComponent(variant, process.env.NODE_ENV === "production" ? {
      target: "e1hk20aw1"
    } : {
      target: "e1hk20aw1",
      label: "Component"
    });
  }
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: "leshen-typography-".concat(variant),
    variant: variant
  }, props, {
    strikethrough: strikethrough,
    customWeight: customWeight
  }), children);
};
var Typography$1 = Typography;

export { Typography$1 as default };
//# sourceMappingURL=index.js.map
